export interface IContract {
  id: number;
  status: 'completed' | 'processing';
  docType: 'lo';
  name: string;
}
